import React, { FC } from "react";
import { YhBox } from "../YhBox";
import { Row } from "antd";
import { __FormItem as FormItem } from "./item";
import { IYhFormItemsBox } from "./Types";


export const __FormItemsBox: FC<IYhFormItemsBox> = ({ items, justify = "start", ...props }) => {
    return <YhBox {...props}>
        <Row
            className={props.IclassName}
            // gutter={[20, 10]}
            justify={justify}
        >
            {items.map((el, index) => <FormItem key={index} {...el} disable={el.disable ?? props.disabled} />)}
        </Row>
    </YhBox>
}
